import React from 'react';
import { Button } from '@/components/shared/button';
import { formatPlaceName, cn } from '@/lib/utils';

type View = 'visualized' | 'snapshot' | 'time';

interface ViewToggleProps {
  selectedCity: string | null;
  activeView: View;
  onViewChange: (view: View) => void;
}

export const ViewToggle: React.FC<ViewToggleProps> = ({
  selectedCity,
  activeView,
  onViewChange,
}) => {
  const city = selectedCity ? formatPlaceName(selectedCity) : 'Selected City';

  const views: { id: View; label: string }[] = [
    { id: 'visualized', label: 'City vs Peers - Visualized' },
    { id: 'snapshot', label: `${city} Snapshot` },
    { id: 'time', label: `${city} Over Time` },
  ];

  return (
    <div className="flex flex-col sm:flex-row justify-center sm:space-x-2 space-y-2 sm:space-y-0 my-4">
      {views.map(({ id, label }) => (
        <Button
          key={id}
          variant={activeView === id ? 'default' : 'outline'}
          onClick={() => onViewChange(id)}
          className={cn("w-full sm:w-auto", {
            "bg-gradient-to-r from-[#ca0270] to-[#f6b90d] text-white hover:opacity-90":
              activeView === id,
          })}
        >
          {label}
        </Button>
      ))}
    </div>
  );
}; 